export const GA4_SELECT_ITEM = 'select_item'
export const GA4_VIEW_ITEM_LIST = 'view_item_list'
export const GA4_VIEW_ITEM = 'view_item'
export const GA4_ADD_TO_WISHLIST = 'add_to_wishlist'
export const GA4_BEGIN_CHECKOUT = 'begin_checkout'
